import clsx from "clsx";
import shape from "../../assets/img/shapes/sun-shape-01.webp";


const SunShape02 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-sun-shape-02", props.className)}>
            <img src={shape} alt="rmdr-sun-shape-02" loading="lazy" width={60} height={61} />
        </div>
    )

}

export default SunShape02;
